import { ReactElement } from 'react';
import { AemPageType, Resource } from '../../../../lib/types/aemDataModels';
import PureLink, { PureLinkVariant } from '../../../common/Link/PureLink';
import { DownloadIcon } from '../../../../lib/icons/DowloadIcon';
import styles from './ResourceItem.module.scss';
import { ExternalIcon } from '../../../../lib/icons/ExternalIcon';

const ResourceItem = ({ label, link, type }: Resource): ReactElement => {
  const ResourceIcon = (() => {
    if (type === AemPageType.internal) {
      return null;
    }
    if (type === AemPageType.external) {
      return ExternalIcon;
    }

    return DownloadIcon;
  })();

  const tabBehaviour = type !== AemPageType.internal ? 'forceNewTab' : 'default';

  return (
    <PureLink
      className={styles.resourceLink}
      href={link}
      tabBehaviour={tabBehaviour}
      {...(!ResourceIcon && { variant: PureLinkVariant.Link })}
    >
      {!!ResourceIcon && <ResourceIcon className={styles.resourceIcon} />}
      {label}
    </PureLink>
  );
};

export default ResourceItem;
